import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import { CustomDialogProps } from 'src/models/DialogBox.interface';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import {
  StyledDialogContent,
  SubmitButton,
  CancelButton,
} from 'src/components/DialogBox/DialogBox.styles';
import {
  CloseIcon,
  StyledDialog,
} from 'src/components/DialogBox/DialogBox.styles';
import { ButtonContainerBox, FormContentBox } from '../POBox/POBox.styles';

const CustomDialog: FC<CustomDialogProps> = ({
  height = '550px',
  width = '730px',
  open,
  handleClose,
  title,
  subtitle,
  children,
  onSubmit,
  smScreen,
  buttonLabel = 'Save',
  buttonWidth = '100px',
  buttonDisabled,
  showCancelButton = false,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width={width}
      height={height}
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>

      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <form onSubmit={onSubmit}>
            <FormContentBox>{children}</FormContentBox>
            <ButtonContainerBox>
              <SubmitButton
                className="btn-primary"
                type="submit"
                disabled={buttonDisabled}
                buttonWidth={buttonWidth}
              >
                {buttonDisabled ? (
                  <CircularProgress
                    size={24}
                    sx={{ color: 'var(--bg-color)' }}
                  />
                ) : (
                  buttonLabel
                )}
              </SubmitButton>
              {showCancelButton && (
                <CancelButton
                  className="btn-inactive"
                  onClick={handleClose}
                  type="button"
                >
                  Cancel
                </CancelButton>
              )}
            </ButtonContainerBox>
          </form>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default CustomDialog;
